import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HardCopyConstants } from '../hard-copy.constants';
import { UpdateHardcopyActivityDTO } from '../models/update-hardcopy-activity-DTO';
import { HardCopyActivityService } from '../services/hard-copy-activity.service';


@Component({
  selector: 'app-hardcopy-activity-confirmation-modal',
  templateUrl: './hardcopy-activity-confirmation-modal.component.html',
  styleUrls: ['./hardcopy-activity-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HardcopyActivityConfirmationModalComponent implements OnInit {
@Input() hardcopyActivityId : any;
@Input() removeActivity:any;
@Input() removedCopiesMax:any;
@Output() closeConfirmationModal = new EventEmitter<boolean>();
@Input() closeConfirmationModalVisible!:boolean;
  constructor(private hardCopyActivityService: HardCopyActivityService, private messageService: MessageService,private cd: ChangeDetectorRef) { }
  display: boolean = true;
  displayConfirmationDialog:boolean=false;
  removedCopiesVal:any;
  removedCopies:any;
  maxRemovedCopies:any;
 updateHardcopyData!: UpdateHardcopyActivityDTO;
 maxValueLimit!:number;

  ngOnInit(): void {
    this.displayConfirmationDialog=false;
    this.maxValueLimit=this.removedCopiesMax;
    this.updateHardcopyData={
      Removedcopies:null
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
        this.maxValueLimit = this.removedCopiesMax;
   }
  }

  confirmClick(buttonClick:any):void
  {
    if(this.removeActivity)
    {
      this.updateHardcopyData.Removedcopies=this.removedCopiesMax;
    }
    else{
      this.updateHardcopyData.Removedcopies=null;
    }
    this.hardCopyActivityService.updateHardcopyActivity(this.hardcopyActivityId, this.updateHardcopyData).subscribe(
      serviceData => {
        this.messageService.add({
        severity: HardCopyConstants.Severity_Info,
        summary: HardCopyConstants.HardCopyActivity_Completed_Success
      });
        
      this.hardCopyActivityService.hardcopyActivityCompleted.next(true);
      this.cd.detectChanges();
      this.reloadHardCopyDetail();
      });
  }

  reloadHardCopyDetail():void
  {
    this.closeConfirmationModalVisible=false;
    this.closeConfirmationModal.emit(this.closeConfirmationModalVisible);
  }

  cancelClick():void{
    this.closeConfirmationModalVisible=false;
    this.closeConfirmationModal.emit(this.closeConfirmationModalVisible);
  }

  onCopiesChanges(keyEvent : any){
    if(Number(keyEvent.target.value) < 1){
      keyEvent.target.value = 1;
    }
    if(Number(keyEvent.target.value) > this.removedCopiesMax){
      keyEvent.target.value = this.removedCopiesMax;
    }
    else{
      this.removedCopiesMax=keyEvent.target.value;
    }
}

}
